document.addEventListener('DOMContentLoaded', function() {
    // Get all product detail buttons
    const buttons = document.querySelectorAll('.product-details-button');
    
    buttons.forEach(function(button) {
        // Find the corresponding open list and button text within the same parent
        const parent = button.closest('.product-details') || button.closest('.product-specifications');
        if (!parent) return;
        
        const openList = parent.querySelector('.product-details-open-list');
        const buttonText = parent.querySelector('.product-details-button-more');
        
        if (button && openList && buttonText) {
            button.addEventListener('click', function() {
                const isOpen = openList.classList.contains('open');
                
                if (isOpen) {
                    // Close: get current height (handle 'auto' case)
                    let currentHeight = openList.scrollHeight;
                    if (openList.style.height === 'auto' || !openList.style.height) {
                        currentHeight = openList.scrollHeight;
                    } else {
                        currentHeight = parseInt(openList.style.height) || openList.scrollHeight;
                    }
                    
                    openList.style.height = currentHeight + 'px';
                    // Force reflow to ensure height is set
                    openList.offsetHeight;
                    // Now animate to 0
                    requestAnimationFrame(function() {
                        openList.style.height = '0px';
                    });
                    openList.classList.remove('open');
                    button.classList.remove('open');
                    buttonText.textContent = 'Read More';
                } else {
                    // Open: ensure height is 0, add open class, then animate to full height
                    openList.style.height = '0px';
                    openList.classList.add('open');
                    button.classList.add('open');
                    buttonText.textContent = 'Read Less';
                    // Force reflow
                    openList.offsetHeight;
                    // Now animate to full height
                    const targetHeight = openList.scrollHeight;
                    requestAnimationFrame(function() {
                        openList.style.height = targetHeight + 'px';
                    });
                }
            });
            
            // Handle transition end to clean up inline styles when open
            openList.addEventListener('transitionend', function() {
                if (openList.classList.contains('open')) {
                    openList.style.height = 'auto';
                }
            });
        }
    });

    // Handle product variant selection and buy now button
    const buyNowButton = document.getElementById('buy-now');
    if (buyNowButton) {
        const productId = buyNowButton.getAttribute('data-product-id');
        
        buyNowButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            if (!window.productCarouselData || !window.productCarouselData.productId) {
                console.error('Product data not found');
                return;
            }

            // Get all selected variant options
            const selectedOptions = {};
            const variantBlocks = document.querySelectorAll('.product-variants-block');
            
            variantBlocks.forEach(function(block) {
                const checkedInput = block.querySelector('input[type="radio"]:checked');
                if (checkedInput) {
                    const optionName = checkedInput.getAttribute('data-option-name');
                    const optionValue = checkedInput.value;
                    selectedOptions[optionName] = optionValue;
                }
            });

            // Find matching variant ID
            const variantId = findVariantId(selectedOptions);
            
            if (variantId) {
                // Add to cart and redirect to checkout
                addToCartAndCheckout(variantId);
            } else {
                // Fallback: redirect to product page
                window.location.href = '/products/' + window.productCarouselData.productHandle;
            }
        });
    }

    // Helper function to find variant ID based on selected options
    function findVariantId(selectedOptions) {
        if (!window.productCarouselData || !window.productCarouselData.variants) {
            return null;
        }

        const variants = window.productCarouselData.variants;
        const optionKeys = Object.keys(selectedOptions);
        
        // Find variant that matches all selected options
        for (let i = 0; i < variants.length; i++) {
            const variant = variants[i];
            let matches = true;
            
            for (let j = 0; j < optionKeys.length; j++) {
                const optionName = optionKeys[j];
                const optionValue = selectedOptions[optionName];
                
                if (!variant.options[optionName] || variant.options[optionName] !== optionValue) {
                    matches = false;
                    break;
                }
            }
            
            if (matches && variant.available) {
                return variant.id;
            }
        }
        
        // If no exact match, return first available variant
        for (let i = 0; i < variants.length; i++) {
            if (variants[i].available) {
                return variants[i].id;
            }
        }
        
        return null;
    }

    // Clear cart and add product, then redirect to checkout
    function addToCartAndCheckout(variantId) {
        // First, clear the cart
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to clear cart');
            }
            return response.json();
        })
        .then(() => {
            // Then add the new product
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            });
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to add to cart');
            }
            return response.json();
        })
        .then(data => {
            // Redirect to checkout
            window.location.href = '/checkout';
        })
        .catch(error => {
            console.error('Error processing cart:', error);
            // Fallback: redirect to product page with variant
            if (window.productCarouselData && window.productCarouselData.productHandle) {
                window.location.href = '/products/' + window.productCarouselData.productHandle + '?variant=' + variantId;
            } else {
                window.location.href = '/cart';
            }
        });
    }

    // Format price in cents to currency string
    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
  function formatMoneyMath(cents) {
        return '$' + (cents / 100).toFixed(0).replace(/\.00$/, '');
    }
    // Update prices based on selected variant
    function updatePrices() {
        if (!window.productCarouselData || !window.productCarouselData.variants) return;

        // Get all selected variant options
        const selectedOptions = {};
        const variantBlocks = document.querySelectorAll('.product-variants-block');
        
        variantBlocks.forEach(function(block) {
            const checkedInput = block.querySelector('input[type="radio"]:checked');
            if (checkedInput) {
                const optionName = checkedInput.getAttribute('data-option-name');
                const optionValue = checkedInput.value;
                selectedOptions[optionName] = optionValue;
            }
        });

        // Find matching variant
        const variant = findVariant(selectedOptions);
        
        if (variant) {
            const priceEl = document.getElementById('product-price');
            const bannerPriceEl = document.querySelector('.banner-price-now');
            const comparePriceEl = document.getElementById('product-compare-price');
            const bannerComparePriceEl = document.querySelector('.banner-price-old');
            const discountEl = document.getElementById('product-discount');
            const bannerdiscountEls = document.querySelectorAll('.banner-discount');
            const afterplayEls = document.querySelectorAll('.afterpay-text');
            const afterplay = variant.price/4;
            console.log("afterplay", afterplayEls)
            if (priceEl) {
                priceEl.textContent = formatMoney(variant.price);
            }
            if (bannerPriceEl) {
                bannerPriceEl.textContent = formatMoney(variant.price);
            }
            if (comparePriceEl && discountEl) {
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    const discount = variant.compare_at_price - variant.price;
                    comparePriceEl.textContent = formatMoney(variant.compare_at_price);
                    discountEl.textContent = '-' + formatMoney(discount) + ' OFF';
                    comparePriceEl.style.display = '';
                    discountEl.style.display = '';
                } else {
                    comparePriceEl.style.display = 'none';
                    discountEl.style.display = 'none';
                }
            }
            if (bannerComparePriceEl && bannerdiscountEls) {
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    const discount = variant.compare_at_price - variant.price;
                    bannerComparePriceEl.textContent = formatMoney(variant.compare_at_price);
                    //  bannerdiscountEl.textContent = '-' + formatMoneyMath(discount);
                        bannerdiscountEls.forEach(el => {
                        el.textContent = '-' + formatMoneyMath(discount);
                        el.style.display = ''; // показуємо
                        });
                    bannerComparePriceEl.style.display = '';
                    // bannerdiscountEl.style.display = '';
                } else {
                    bannerComparePriceEl.style.display = 'none';
                    // bannerdiscountEl.style.display = 'none';
                    bannerdiscountEls.forEach(el => {
                    el.style.display = 'none'; // ховаємо всі
                    });
                }
            }
            if (afterplayEls && afterplay) {
                afterplayEls.forEach(el => {
                        el.textContent = formatMoney(afterplay);
                        });
            }
        }
    }

    // Helper function to find variant based on selected options
    function findVariant(selectedOptions) {
        if (!window.productCarouselData || !window.productCarouselData.variants) {
            return null;
        }

        const variants = window.productCarouselData.variants;
        const optionKeys = Object.keys(selectedOptions);
        
        for (let i = 0; i < variants.length; i++) {
            const variant = variants[i];
            let matches = true;
            
            for (let j = 0; j < optionKeys.length; j++) {
                const optionName = optionKeys[j];
                const optionValue = selectedOptions[optionName];
                
                if (!variant.options[optionName] || variant.options[optionName] !== optionValue) {
                    matches = false;
                    break;
                }
            }
            
            if (matches) {
                return variant;
            }
        }
        
        return variants[0] || null;
    }

    // Handle variant radio button changes
    const variantInputs = document.querySelectorAll('.product-variant input[type="radio"]');
    variantInputs.forEach(function(input) {
        input.addEventListener('change', function() {
            // Remove active class from all variants in the same group
            const variantBlock = input.closest('.product-variants-block');
            if (variantBlock) {
                const allVariants = variantBlock.querySelectorAll('.product-variant');
                allVariants.forEach(function(variant) {
                    variant.classList.remove('variant-selected');
                });
                
                // Add active class to selected variant
                const selectedVariant = input.closest('.product-variant');
                if (selectedVariant) {
                    selectedVariant.classList.add('variant-selected');
                }
            }

            // Update prices when variant changes
            updatePrices();
        });
        
        // Set initial state for checked inputs
        if (input.checked) {
            const selectedVariant = input.closest('.product-variant');
            if (selectedVariant) {
                selectedVariant.classList.add('variant-selected');
            }
        }
    });

    // Initialize prices on page load
    updatePrices();
});

